// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"LoginForm_formWrapper__2hTQc","loginForm":"LoginForm_loginForm__Wuf5X"};